angular.module('impactx.invoice').controller('CustomInvoiceOverviewCtrl', [
    'selectedListItems',
    CustomInvoiceOverviewCtrl]);

function CustomInvoiceOverviewCtrl(selectedListItems) {
    var self = this;

    function getDetailLink () {
        return 'custominvoiceview/' + selectedListItems.getFirstSelectedId();
    }

    function getMatchLink () {
        return 'custominvoicematch/' + selectedListItems.getFirstSelectedId();
    }

    function getAcceptUnmatchedLink () {
        return 'invoice/acceptunmatched/' + selectedListItems.getFirstSelectedId();
    }

    function isUnmatched () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().isUnmatched.value
    }

    function canMatch () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canMatch.value
    }

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewInvoice'
        },
        {
            label: "match",
            linkFunction: getMatchLink,
            type: 'link',
            condition: canMatch,
            process: "ViewInvoice"
        },
        {
            label: "acceptunmatched",
            linkFunction: getAcceptUnmatchedLink,
            type: 'link',
            condition: isUnmatched,
            process: "AcceptUnmatchedInvoice"
        }
    ];

    self.meta = {
        rowTemplate: 'modules/invoice/templates/custominvoicelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: self,
        endpoint: '/invoice/customlistoverview',
        id: "custominvoiceoverview",
        excelExport: true,
        buttonDefinition: buttonDefinition
    };
    self.getMeta = function () {
        return self.meta;
    };
}